import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register, apiError } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: "", email: "", password: "", whatsapp: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register({ ...form, reseller_id: params.get("r") || undefined });
      const loja = params.get("loja");
      navigate(loja ? `/loja/${loja}` : "/painel");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10 grid-bg">
      <div className="absolute right-4 top-4"><ThemeToggle /></div>
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 shadow-sm">
        <div className="flex justify-center"><Logo /></div>
        <h1 className="mt-6 text-center font-heading text-xl font-bold tracking-tight sm:text-2xl">Criar conta</h1>
        <p className="mt-1 text-center text-sm text-muted-foreground">Comece a ativar seus aplicativos</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Nome</Label>
            <Input id="name" value={form.name} onChange={set("name")} required data-testid="register-name-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" type="email" value={form.email} onChange={set("email")} required data-testid="register-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="whatsapp">WhatsApp (opcional)</Label>
            <Input id="whatsapp" value={form.whatsapp} onChange={set("whatsapp")} placeholder="+55 11 99999-9999" data-testid="register-whatsapp-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Senha</Label>
            <Input id="password" type="password" value={form.password} onChange={set("password")} required minLength={8} data-testid="register-password-input" />
            <p className="text-xs text-muted-foreground" data-testid="register-password-hint">
              Mínimo de 8 caracteres, com pelo menos uma letra e um número.
            </p>
          </div>
          {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Criar conta
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-muted-foreground">
          Já tem conta?{" "}
          <Link to="/login" className="font-medium text-primary hover:underline" data-testid="to-login-link">Entrar</Link>
        </p>
      </div>
    </div>
  );
}
